import { ApiClient } from "../ApiClient";

/**
 * Track a website visit
 * @param {Object} visitData - The visit data to track
 * @param {string} visitData.cmpg_identifier - Campaign identifier
 * @param {string} visitData.referrer - Referrer URL
 * @returns {Promise<Response>} API response
 */
export const trackWebsiteVisit = async (visitData) => {
  // ApiClient.post handles baseUrl, JSON stringification, and headers.
  // Note: These usually don't strictly require CSRF if they are open-tracking,
  // but ApiClient.post will include it by default for consistency.
  return ApiClient.post("/utils/cmpg-tracker-wv", visitData);
};

/**
 * Track a conversion
 * @param {Object} conversionData - The conversion data to track
 * @param {string} conversionData.cmpg_identifier - Campaign identifier
 * @param {string} conversionData.purpose - Conversion goal (e.g., "create filing")
 * @param {string} conversionData.type - Type of conversion ("CLK", "UNK")
 * @param {string} conversionData.referrer - Referrer domain
 * @returns {Promise<Response>} API response
 */
export const trackConversion = async (conversionData) => {
  return ApiClient.post("/utils/cmpg-tracker-conversion", conversionData);
};
